import { render, staticRenderFns } from "./SessionLostModal.vue?vue&type=template&id=7855bc44&scoped=true&"
import script from "./SessionLostModal.vue?vue&type=script&lang=js&"
export * from "./SessionLostModal.vue?vue&type=script&lang=js&"
import style0 from "./SessionLostModal.vue?vue&type=style&index=0&id=7855bc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7855bc44",
  null
  
)

export default component.exports